import { get, post, patch, remove } from '@/helpers/httpHandler';

export default {
  getPosts({ commit }, { params } = {}) {
    return get(`/posts`, params).then(response => {
      return response;
    });
  },

  update({ commit }, payload) {
    return patch(`/posts/${payload.id}`, payload).then(response => {
      return response;
    });
  },

  store: ({ commit }, payload) => {
    return post(`/posts`, payload).then(response => {
      return response;
    });
  },

  show({ commit }, id) {
    return get(`/posts/${id}`).then(response => {
      return response;
    });
  },

  remove({ commit }, id) {
    return remove(`/posts/${id}`).then(response => {
      return response;
    });
  },

  authorCompanies({ commit }) {
    return get(`posts/author-companies`).then(response => {
      return response;
    });
  }
};
